import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "spinner", "label", "status"]
  static values  = { timeout: { type: Number, default: 15000 } }

  async refresh(event) {
    event.preventDefault()
    this.setLoading(true)
    this.setStatus("", "")

    const timeoutId = setTimeout(() => {
      this.setLoading(false)
      this.setStatus("Timed out — DB may be under load, try again later", "error")
    }, this.timeoutValue)

    try {
      const response = await fetch(this.element.action, {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
          "Accept": "text/vnd.turbo-stream.html"
        }
      })

      clearTimeout(timeoutId)

      if (!response.ok) throw new Error(`Server error ${response.status}`)

      const html = await response.text()
      Turbo.renderStreamMessage(html)
      this.setStatus("Updated from DB", "success")
    } catch (e) {
      clearTimeout(timeoutId)
      this.setStatus("Error: " + e.message, "error")
    } finally {
      this.setLoading(false)
    }
  }

  setLoading(loading) {
    this.buttonTarget.disabled = loading
    this.spinnerTarget.classList.toggle("hidden", !loading)
    this.labelTarget.classList.toggle("hidden", loading)
  }

  setStatus(message, type) {
    this.statusTarget.textContent = message
    this.statusTarget.className = {
      error:   "text-xs text-red-500 mt-1",
      success: "text-xs text-green-600 mt-1",
      "":      "text-xs text-gray-400 mt-1"
    }[type] ?? "text-xs text-gray-400 mt-1"
  }
}
